import { getSearchParamValue } from './path';

const omitKeys = ['jti', 'origin_jti'];

const parseJwt = (token: string) => {
  try {
    const parse = (str: string) => {
      const base64 = str.replace(/-/g, '+').replace(/_/g, '/');
      const uriData = window
        .atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('');
      const jsonStrData = decodeURIComponent(uriData);

      return JSON.parse(jsonStrData);
    };

    const [header, payload] = token.split('.');

    return {
      header: parse(header),
      payload: parse(payload),
    };
  } catch (error) {
    console.log('unable to parse JWT', error);
  }
};

const sha256 = async (source: string) => {
  const sourceBytes = new TextEncoder().encode(source);
  const digest = await crypto.subtle.digest('SHA-256', sourceBytes);
  const resultBytes = [...new Uint8Array(digest)];

  return resultBytes.map((x) => x.toString(16).padStart(2, '0')).join('');
};

export const createHashFromToken = async (token: string) => {
  const parsedToken = parseJwt(token);

  if (parsedToken) {
    parsedToken.payload = Object.fromEntries(
      Object.entries(parsedToken.payload).filter(
        ([k]) => omitKeys.indexOf(k) === -1,
      ),
    );

    const hashedTokenData = await sha256(JSON.stringify(parsedToken));

    return hashedTokenData;
  }
};

export const compareTokenHash = async (token: string, hash: string) => {
  const hashedTokenData = await createHashFromToken(token);

  return hash === hashedTokenData;
};

export const getExternalUrlHash = () =>
  getSearchParamValue(window.location.search, 'authHash');
